export default {
  Codigo: null,
  Usuario: null,
  Nombre: null,
  Apellido: null,
  Password: null,
  Activo: true,
  CodigoUsuarioCreacion: null,
  FechaCreacion: null,
  CodigoUsuarioActualizacion: null,
  FechaActualizacion: null,
  RolUsuario: [],
};
